import React, { useState, useEffect } from 'react';
import { addBrandToFirestore, getBrandsFromFirestore, deleteBrandFromFirestore } from '../../firebase/brandService';
import { addGenreToFirestore, getGenresFromFirestore, deleteGenreFromFirestore } from '../../firebase/genreService';
import { addColorToFirestore, getColorsFromFirestore, deleteColorFromFirestore } from '../../firebase/colorService';
import { useAuth } from '../../firebase/AuthContext';
import { addStateToFirestore, getStatesFromFirestore, deleteStateFromFirestore } from '../../firebase/stateService';

import MasterManager from '../../Components/MasterManager/MasterManager';
import styles from './Settings.module.css';
import { Link } from 'react-router-dom';

const Settings = () => {
  const [brandName, setBrandName] = useState('');
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);
  // ジャンル管理
  const [genreName, setGenreName] = useState('');
  const [genres, setGenres] = useState([]);
  const [genreLoading, setGenreLoading] = useState(true);
  // 色管理
  const [colorName, setColorName] = useState('');
  const [colors, setColors] = useState([]);
  const [colorLoading, setColorLoading] = useState(true);
  const { user } = useAuth();
  // 状態（State）管理
  const [stateName, setStateName] = useState('');
  const [states, setStates] = useState([]);
  const [stateLoading, setStateLoading] = useState(true);

  // 状態（State）取得
  const fetchStates = async () => {
    if (!user) return;
    setStateLoading(true);
    const data = await getStatesFromFirestore(user.uid);
    setStates(data);
    setStateLoading(false);
  };

  // 状態（State）追加
  const handleAddState = async (e) => {
    e.preventDefault();
    if (!stateName.trim()) return;
  await addStateToFirestore(stateName.trim(), user.uid, 'post');
    setStateName('');
    fetchStates();
  };

  // 状態（State）削除
  const handleDeleteState = async (id) => {
    if (!window.confirm('本当に削除しますか？')) return;
    await deleteStateFromFirestore(id);
    fetchStates();
  };

  useEffect(() => {
    if (!user) return;
    (async () => {
      setLoading(true);
      const data = await getBrandsFromFirestore(user.uid);
      setBrands(data);
      setLoading(false);
    })();
    (async () => {
      setGenreLoading(true);
      const data = await getGenresFromFirestore(user.uid);
      setGenres(data);
      setGenreLoading(false);
    })();
    (async () => {
      setColorLoading(true);
      const data = await getColorsFromFirestore(user.uid);
      setColors(data);
      setColorLoading(false);
    })();
    fetchStates();
  }, [user]);

  // ブランド追加
  const handleAddBrand = async (e) => {
    e.preventDefault();
    if (!brandName.trim() || !user) return;
    const id = await addBrandToFirestore(brandName.trim(), user.uid);
    setBrands([...brands, { id, name: brandName.trim(), uid: user.uid }]);
    setBrandName('');
  };
  // ブランド削除
  const handleRemoveBrand = async (idx) => {
    if (!user) return;
    const brand = brands[idx];
    await deleteBrandFromFirestore(brand.id, user.uid);
    setBrands(brands.filter((_, i) => i !== idx));
  };

  // 色追加
  const handleAddColor = async (e) => {
    e.preventDefault();
    if (!colorName.trim() || !user) return;
    const id = await addColorToFirestore(colorName.trim(), user.uid);
    setColors([...colors, { id, name: colorName.trim(), uid: user.uid }]);
    setColorName('');
  };
  // 色削除
  const handleRemoveColor = async (idx) => {
    if (!user) return;
    const color = colors[idx];
    await deleteColorFromFirestore(color.id, user.uid);
    setColors(colors.filter((_, i) => i !== idx));
  };

  // ジャンル追加
  const handleAddGenre = async (e) => {
    e.preventDefault();
    if (!genreName.trim() || !user) return;
    const id = await addGenreToFirestore(genreName.trim(), user.uid);
    setGenres([...genres, { id, name: genreName.trim(), uid: user.uid }]);
    setGenreName('');
  };
  // ジャンル削除
  const handleRemoveGenre = async (idx) => {
    if (!user) return;
    const genre = genres[idx];
    await deleteGenreFromFirestore(genre.id, user.uid);
    setGenres(genres.filter((_, i) => i !== idx));
  };

  return (
    <div className={styles.container}>
      <div className={styles.verticalButtonGroup}>
        <Link to="/settings/post" className={styles.linkCard}>
          投稿設定ページへ
        </Link>
        <Link to="/settings/tool" className={styles.linkCard}>
          道具設定ページへ
        </Link>
      </div>
    </div>
  );
}

export default Settings;
//
